import Topbar from '../layouts/Topbar';
import { Box, Grid2, Typography } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CategoryIcon from '@mui/icons-material/Category';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import GroupIcon from '@mui/icons-material/Group';
import BannerIcon from '@mui/icons-material/Image';
import NotificationsIcon from '@mui/icons-material/Notifications';
import WorkIcon from '@mui/icons-material/Work';
import PeopleIcon from '@mui/icons-material/People';
import ReportIcon from '@mui/icons-material/Assessment';
import SettingsIcon from '@mui/icons-material/Settings';
import ForumIcon from '@mui/icons-material/Forum';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import FolderIcon from '@mui/icons-material/Folder';
import StarIcon from '@mui/icons-material/Star';

const AccessiblePages = () => {
    const iconStyle = { color: "#71839b" };
    const pageIcons = {
        dashboard: <DashboardIcon sx={iconStyle} />,
        consultation: <ForumIcon sx={iconStyle} />,
        orders: <ShoppingCartIcon sx={iconStyle} />,
        category: <CategoryIcon sx={iconStyle} />,
        subcategory: <FolderIcon sx={iconStyle} />,
        design: <DesignServicesIcon sx={iconStyle} />,
        designtype: <StarIcon sx={iconStyle} />,
        users: <GroupIcon sx={iconStyle} />,
        banners: <BannerIcon sx={iconStyle} />,
        Notifications: <NotificationsIcon sx={iconStyle} />,
        employees: <WorkIcon sx={iconStyle} />,
        staff: <PeopleIcon sx={iconStyle} />,
        Reports: <ReportIcon sx={iconStyle} />,
        settings: <SettingsIcon sx={iconStyle} />,
        Access: <AddCircleIcon sx={iconStyle} />,
    };

    const adminPages = [
        "dashboard",
        "consultation",
        "orders",
        "category",
        "subcategory",
        "design",
        "designtype",
        "users",
        "banners",
        "Notifications",
        "employees",
        "staff",
        "Reports",
        "settings",
        "Access",
    ];

    const seniorDesignerPages = [
        "dashboard",
        "consultation",
        "orders",
        "category",
        "subcategory",
        "designtype",
        "design",
        "users",
        "staff",
        "settings",
    ];

    const juniorDesignerPages = [
        "dashboard",
        "consultation",
        "orders",
        "users",
        "settings",
    ];

    return (
        <>
            <Topbar />
            <section className="admin-catalogue">
                <div className='page-headers'>
                    <Typography variant="h5" sx={{ mx: 2, }}>
                        Accessible Pages:
                    </Typography>
                </div>
                <Grid2 container spacing={2}>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                        <section className="acess-card">
                            <div className='page-headers'>
                                <Typography variant="h5" >
                                    Admin:
                                </Typography>
                            </div>
                            {adminPages.map((path) => (
                                <Box key={path} display="flex" alignItems="center" gap={2} mt={2}>
                                    {pageIcons[path] || <FolderIcon color="disabled" />}
                                    <Typography className='page-text'>
                                        {path}
                                    </Typography>
                                </Box>
                            ))}
                        </section>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
                        <section className="acess-card">
                            <div className='page-headers'>
                                <Typography variant="h5" >
                                    Senior Designer:
                                </Typography>
                            </div>
                            {seniorDesignerPages.map((path) => (
                                <Box key={path} display="flex" alignItems="center" gap={2} mt={2}>
                                    {pageIcons[path] || <FolderIcon color="disabled" />}
                                    <Typography className='page-text'>
                                        {path}
                                    </Typography>
                                </Box>
                            ))}
                        </section>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
                        <section className="acess-card">
                            <div className='page-headers'>
                                <Typography variant="h5">
                                    Junior Designer:
                                </Typography>
                            </div>
                            {juniorDesignerPages.map((path) => (
                                <Box key={path} display="flex" alignItems="center" gap={2} mt={2}>
                                    {pageIcons[path] || <FolderIcon color="disabled" />}
                                    <Typography className='page-text'>
                                        {path}
                                    </Typography>
                                </Box>
                            ))}
                        </section>
                    </Grid2>
                </Grid2>
            </section>

        </>
    )
}

export default AccessiblePages